/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putPreferencesV2.defs.js'
export * as $defs from './putPreferencesV2.defs.js'
